module.exports = __webpack_public_path__ + "img/title7.5f897967.png";